import { AppTheme } from '@backstage/core-plugin-api';
import { UnifiedThemeProvider } from '@backstage/theme';
import DarkIcon from '@material-ui/icons/Brightness2';
import { createElement } from 'react';
import { adpDarkTheme } from './adp';

export const themes: AppTheme[] = [
  {
    id: 'adp',
    title: 'ADP Dark',
    variant: 'dark',
    icon: createElement(DarkIcon),
    Provider: ({ children }) =>
      createElement(UnifiedThemeProvider, {
        theme: adpDarkTheme,
        children,
      }),
  },
];
